import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import PrivacyWarningContainer from 'LiveBoard/containers/PrivacyWarningContainer'
import { Header } from './Header'
import { Banner } from 'LiveBoard/components/shared/Banner'
import { GreetingCard } from './GreetingCard'
import { LiveEventContainer } from 'LiveBoard/components/shared/LiveEvent'
import { SellerCard } from './SellerCard'
import { Footer } from 'LiveBoard/components/shared/Footer'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

// Live board is the component
// that renders the entire live board
const LiveBoard = ({
  children,
  lead,
  presenter,
  isItemView,
  isGatingFormOpened,
  isClassicItemView,
  isGreetingOpen,
  onGreetingCardClose,
  allowEmbedding,
  campaign: {
    board_id: boardId,
    general,
    header,
    footer,
    contact_card: contactCard,
    banner,
    themeColorHex,
    headerTextColorHex,
    bannerTextColorHex,
    live_event: liveEvent
  },
  hasConsent
}) => {

  const renderFooter = () => {
    const showFooter = !footer.custom && footer.show

    if(!showFooter) {
      return null
    }

    if(isItemView) {
       return null
    }

    return (
      <Footer
        config={{...footer, headerLogo: header.logo}}
        themeColorHex={themeColorHex} />
    )
  }

  const sessionGuid = useSelector(state => state.session.guid)
  if (FollozeState) {
    FollozeState.getSessionGuid = () => sessionGuid
  }

  return (
    <main className={`live-board-desktop ${allowEmbedding ? 'embedded' : ''}`}>
      <PrivacyWarningContainer />
      <section className='campaign-container'>
        { header.show &&
            <Header
              boardId={boardId}
              config={header}
              themeColorHex={themeColorHex}
              textColor={headerTextColorHex}
              banner={banner}
              isGatingFormOpened={isGatingFormOpened}
              isClassicItemView={isClassicItemView} />
        }
        { contactCard.card.show && !isEmpty(presenter) &&
          <CSSTransition
            timeout={{ enter: 500, exit: 0 }}
            classNames='slide'
            in={isItemView}
            appear>
            <SellerCard
              config={contactCard.card}
              lead={lead}
              seller={presenter}
              themeColorHex={themeColorHex}
              shouldStickToTop={isItemView}
              isGreetingOpen={isGreetingOpen} />
          </CSSTransition>
        }
        <Banner
          showHeader={header.show}
          config={banner}
          themeColorHex={themeColorHex}
          textColor={bannerTextColorHex}
          isItemView={isItemView} />
        {!isEmpty(liveEvent) && liveEvent.show && (
          <LiveEventContainer
            boardId={boardId}
            liveEventConfiguration={liveEvent}
            isItemView={isItemView}
            themeColorHex={themeColorHex} />
          )
        }
        { children }
        { isGreetingOpen && (
            <GreetingCard
              lead={lead}
              config={general.greetings}
              onClose={onGreetingCardClose}
              hasSellerCard={contactCard.card.show}
              shouldStickToTop={isItemView} />
          )
        }
        {renderFooter()}
      </section>
    </main>
  )
}

LiveBoard.propTypes = {
  campaign: PropTypes.object.isRequired,
  lead: PropTypes.object.isRequired,
  presenter: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  isItemView: PropTypes.bool.isRequired,
  isGatingFormOpened: PropTypes.bool.isRequired,
  isGreetingOpen: PropTypes.bool,
  onGreetingCardClose: PropTypes.func,
  isClassicItemView: PropTypes.bool.isRequired,
  allowEmbedding: PropTypes.bool
}

LiveBoard.defaultProps = {
  isGatingFormOpened: false,
  isClassicItemView: false
}

export default LiveBoard
